import { useMutation, useQueryClient } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import templateApi from '../services/templateApi';
import { extractMessageFromError } from '../utils/backEndErrorMessages';
import { TEMPLATE_STATUS, ValidUpgradableTemplateStatus } from '../types';
import { AxiosError } from 'axios';
import { BaseQueryKey as TemplatesQueryKey } from './useTemplates';

export const useUpdateTemplateStatus = (templateUUID: string) => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation(
    (status: ValidUpgradableTemplateStatus) => {
      return templateApi.updateTemplateStatus(companyId, templateUUID, status);
    },
    {
      onSuccess: (data) => {
        const requestStatus = JSON.parse(data.config.data as unknown as string)['status'];
        const successText =
          requestStatus === TEMPLATE_STATUS.archived
            ? t('template.hooks.status.archived')
            : t('template.hooks.status.restored');
        showToast({
          title: t('common.toast.success'),
          description: t('template.hooks.status.success') + successText,
          status: 'success',
          'data-cy': 'toast-update-status-success',
        });

        queryClient.invalidateQueries([TemplatesQueryKey]);
        queryClient.invalidateQueries(['template']);
      },
      onError: (error: AxiosError) => {
        const errorMessage = extractMessageFromError(error);
        showToast({
          title: t('common.toast.error'),
          description: errorMessage,
          status: 'error',
          'data-cy': 'toast-update-status-error',
        });
      },
    },
  );
};
